import { Component, Input } from '@angular/core';
import { UserSnapshotResponse } from '../../../../services/user-analytics/user-analytics.model';

@Component({
    selector: 'app-user-kpi-cards',
    templateUrl: './user-kpi-cards.component.html',
    styleUrls: ['./user-kpi-cards.component.scss'],
})
export class UserKpiCardsComponent {
    @Input() snapshot: UserSnapshotResponse;
}
